/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listHealthLeaves = /* GraphQL */ `
  query ListHealthLeaves(
    $customerId: String!
    $location: String
    $limit: Int
    $nextToken: String
  ) {
    listHealthLeaves(
      customerId: $customerId
      location: $location
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        pk
        sk
        entity
        customerId
        locationId
        locationName
        nodeId
        nodeName
        deviceId
        deviceName
        serviceType
        isOnline
        lastSeenEpochMs
        isExpectedOnline
        author
        reason
        toggleTimestamp
        assignedWatcher
      }
      nextToken
      limit
    }
  }
`;
export const getTimelapseVideo = /* GraphQL */ `
  query GetTimelapseVideo($input: GetTimelapseVideoInput!) {
    getTimelapseVideo(input: $input)
  }
`;
export const getHlsUrl = /* GraphQL */ `
  query GetHlsUrl($streamName: String!) {
    getHlsUrl(streamName: $streamName)
  }
`;
export const getSignedUrlAction = /* GraphQL */ `
  query GetSignedUrlAction($input: GetSignedUrlActionInput!) {
    getSignedUrlAction(input: $input)
  }
`;
export const getGroupsByClient = /* GraphQL */ `
  query GetGroupsByClient($input: GetGroupsByClientInput!) {
    getGroupsByClient(input: $input) {
      items {
        id
        customerId
        clientId
        groupName
        createdAt
      }
      nextToken
      limit
    }
  }
`;
export const getGroupByClientId = /* GraphQL */ `
  query GetGroupByClientId($input: GetGroupByClientIdInput!) {
    getGroupByClientId(input: $input) {
      id
      customerId
      clientId
      groupName
      createdAt
    }
  }
`;
export const getClientsByCustomer = /* GraphQL */ `
  query GetClientsByCustomer($input: GetClientsByCustomerInput!) {
    getClientsByCustomer(input: $input) {
      items {
        id
        clientName
        customerId
      }
      nextToken
      limit
    }
  }
`;
export const getAllVideosByGroup = /* GraphQL */ `
  query GetAllVideosByGroup($input: GetAllVideosByGroupInput!) {
    getAllVideosByGroup(input: $input) {
      items {
        id
        customerId
        clientId
        groupId
        videoName
        videoMethod
        windspeed
        geometry
        fov
        isVideoProcessed
        annotations
        sourceS3Key
        modelOutputS3Key
        notes
        outputMeasurement
        videoState
      }
      nextToken
      limit
    }
  }
`;
export const getAllVideosByState = /* GraphQL */ `
  query GetAllVideosByState($input: GetAllVideosByStateInput!) {
    getAllVideosByState(input: $input) {
      items {
        id
        customerId
        clientId
        groupId
        videoName
        videoMethod
        windspeed
        geometry
        fov
        isVideoProcessed
        annotations
        sourceS3Key
        modelOutputS3Key
        notes
        outputMeasurement
        videoState
      }
      nextToken
      limit
    }
  }
`;
export const getAllVideosByClient = /* GraphQL */ `
  query GetAllVideosByClient($input: GetAllVideosByClientInput) {
    getAllVideosByClient(input: $input) {
      items {
        id
        customerId
        clientId
        groupId
        videoName
        videoMethod
        windspeed
        geometry
        fov
        isVideoProcessed
        annotations
        sourceS3Key
        modelOutputS3Key
        notes
        outputMeasurement
        videoState
      }
      nextToken
      limit
    }
  }
`;
export const getLicensePlatesByCustomer = /* GraphQL */ `
  query GetLicensePlatesByCustomer($input: GetLicensePlatesByCustomerInput!) {
    getLicensePlatesByCustomer(input: $input) {
      items {
        id
        categoryId
        company
        driverName
        licensePlate
      }
      nextToken
      limit
    }
  }
`;
export const getLicensePlate = /* GraphQL */ `
  query GetLicensePlate($categoryId: String!, $licensePlateId: String!) {
    getLicensePlate(categoryId: $categoryId, licensePlateId: $licensePlateId) {
      id
      categoryId
      company
      driverName
      licensePlate
    }
  }
`;
export const getCategoriesByCustomer = /* GraphQL */ `
  query GetCategoriesByCustomer($input: GetCategoriesByCustomerInput!) {
    getCategoriesByCustomer(input: $input) {
      items {
        id
        categoryName
        isAlertEnabled
      }
      nextToken
      limit
    }
  }
`;
export const getTagsByCustomer = /* GraphQL */ `
  query GetTagsByCustomer($input: GetTagsByCustomerInput!) {
    getTagsByCustomer(input: $input) {
      items {
        id
        tagName
      }
      nextToken
      limit
    }
  }
`;
export const getTagAssociations = /* GraphQL */ `
  query GetTagAssociations($input: GetTagAssociationsInput!) {
    getTagAssociations(input: $input) {
      items {
        id
        associationId
        tagName
      }
      nextToken
      limit
    }
  }
`;
export const getCategoryById = /* GraphQL */ `
  query GetCategoryById($input: GetCategoryInput!) {
    getCategoryById(input: $input) {
      id
      categoryName
      isAlertEnabled
    }
  }
`;
export const getClientById = /* GraphQL */ `
  query GetClientById($input: GetClientInput!) {
    getClientById(input: $input) {
      id
      clientName
      customerId
    }
  }
`;
export const getNodeById = /* GraphQL */ `
  query GetNodeById($nodeId: String!) {
    getNodeById(nodeId: $nodeId) {
      customerId
      locationId
      id
      nodeName
      nodeId
      level
      referenceId
      devices {
        customerId
        locationId
        locationName
        id
        name
        status
        nodeId
        nodeName
        makeModelId
        cameraIpAddress
        deviceData {
          hasPanTilt
          hasRecordVideo
          hasZoom
          keyFrame
          panTiltIP
          panTiltType
          protocol
          recentFrame
          rtspHost
          sourceVideo
          signedUrlKeyFrame
          signedUrlRecentFrame
        }
        currentPosition {
          pan
          tilt
          zoom
        }
        healthData {
          lastAlive
          isOnline
        }
        skuNumber
        skuName
        serialNumber
        componentSerialNumber
        commissionedAt
        derivedHealth
      }
      serviceData
      deviceData
      onboardCommand
      tags {
        id
        tagName
      }
      nodeIP
      isOnline
    }
  }
`;
export const getServiceById = /* GraphQL */ `
  query GetServiceById($input: GetServiceInput!) {
    getServiceById(input: $input) {
      nodeId
      customerId
      locationId
      deviceId
      serviceType
      configuration
      id
      healthData
      isRunning
      modelAlertSettingsId
      modelAlertSettings {
        id
        serviceId
        customerId
        deviceId
        timeZone
        modelAlertParameters {
          objectType
          enabled
          activeDays
          schedules {
            dayOfWeek
            dailyTimeRange {
              startMinutesFromMidnight
              endMinutesFromMidnight
            }
          }
        }
      }
    }
  }
`;
export const getModelAlertSettings = /* GraphQL */ `
  query GetModelAlertSettings($input: GetModelAlertSettingsInput!) {
    getModelAlertSettings(input: $input) {
      items {
        id
        serviceId
        customerId
        deviceId
        timeZone
        modelAlertParameters {
          objectType
          enabled
          activeDays
          schedules {
            dayOfWeek
            dailyTimeRange {
              startMinutesFromMidnight
              endMinutesFromMidnight
            }
          }
        }
      }
      nextToken
      limit
    }
  }
`;
export const getServices = /* GraphQL */ `
  query GetServices(
    $limit: Int
    $nextToken: String
    $modelAlertSettingsSelectionKey: SelectionKey
    $customerId: String
    $locationId: String
  ) {
    getServices(
      limit: $limit
      nextToken: $nextToken
      modelAlertSettingsSelectionKey: $modelAlertSettingsSelectionKey
      customerId: $customerId
      locationId: $locationId
    ) {
      items {
        nodeId
        customerId
        locationId
        deviceId
        serviceType
        configuration
        id
        healthData
        isRunning
        modelAlertSettingsId
        modelAlertSettings {
          id
          serviceId
          customerId
          deviceId
          timeZone
          modelAlertParameters {
            objectType
            enabled
            activeDays
            schedules {
              dayOfWeek
              dailyTimeRange {
                startMinutesFromMidnight
                endMinutesFromMidnight
              }
            }
          }
        }
      }
      nextToken
      limit
    }
  }
`;
export const getServicesByDevice = /* GraphQL */ `
  query GetServicesByDevice($deviceId: String!, $nextToken: String) {
    getServicesByDevice(deviceId: $deviceId, nextToken: $nextToken) {
      items {
        nodeId
        customerId
        locationId
        deviceId
        serviceType
        configuration
        id
        healthData
        isRunning
        modelAlertSettingsId
        modelAlertSettings {
          id
          serviceId
          customerId
          deviceId
          timeZone
          modelAlertParameters {
            objectType
            enabled
            activeDays
            schedules {
              dayOfWeek
              dailyTimeRange {
                startMinutesFromMidnight
                endMinutesFromMidnight
              }
            }
          }
        }
      }
      nextToken
      limit
    }
  }
`;
export const getServicesByNode = /* GraphQL */ `
  query GetServicesByNode(
    $nodeId: String!
    $modelAlertSettingsSelectionKey: SelectionKey
    $nextToken: String
  ) {
    getServicesByNode(
      nodeId: $nodeId
      modelAlertSettingsSelectionKey: $modelAlertSettingsSelectionKey
      nextToken: $nextToken
    ) {
      items {
        nodeId
        customerId
        locationId
        deviceId
        serviceType
        configuration
        id
        healthData
        isRunning
        modelAlertSettingsId
        modelAlertSettings {
          id
          serviceId
          customerId
          deviceId
          timeZone
          modelAlertParameters {
            objectType
            enabled
            activeDays
            schedules {
              dayOfWeek
              dailyTimeRange {
                startMinutesFromMidnight
                endMinutesFromMidnight
              }
            }
          }
        }
      }
      nextToken
      limit
    }
  }
`;
export const getDTObject = /* GraphQL */ `
  query GetDTObject($objectId: String!) {
    getDTObject(objectId: $objectId) {
      id
      version
      objectId
      objectName
      objectType
      objectManufacturerName
      isCustomerObject
      filesInfo {
        id
        originalFileName
        contentType
        useType
        key
      }
    }
  }
`;
export const getDTObjects = /* GraphQL */ `
  query GetDTObjects {
    getDTObjects {
      id
      version
      objectId
      objectName
      objectType
      objectManufacturerName
      isCustomerObject
      filesInfo {
        id
        originalFileName
        contentType
        useType
        key
      }
    }
  }
`;
export const getCustomerDTObject = /* GraphQL */ `
  query GetCustomerDTObject($customerId: String, $objectId: String!) {
    getCustomerDTObject(customerId: $customerId, objectId: $objectId) {
      id
      version
      objectId
      objectName
      objectType
      objectManufacturerName
      isCustomerObject
      filesInfo {
        id
        originalFileName
        contentType
        useType
        key
      }
    }
  }
`;
export const getCustomerDTObjects = /* GraphQL */ `
  query GetCustomerDTObjects($customerId: String) {
    getCustomerDTObjects(customerId: $customerId) {
      id
      version
      objectId
      objectName
      objectType
      objectManufacturerName
      isCustomerObject
      filesInfo {
        id
        originalFileName
        contentType
        useType
        key
      }
    }
  }
`;
export const getDTFile = /* GraphQL */ `
  query GetDTFile($key: String) {
    getDTFile(key: $key) {
      key
      url
    }
  }
`;
export const getDTFiles = /* GraphQL */ `
  query GetDTFiles($keys: [String]) {
    getDTFiles(keys: $keys) {
      key
      url
    }
  }
`;
export const getDTProject = /* GraphQL */ `
  query GetDTProject($customerId: String!, $projectId: String!) {
    getDTProject(customerId: $customerId, projectId: $projectId) {
      id
      projectId
      customerId
      displayName
      lastModifierUserName
      lastModificationDate
      configURL
      withKMZLayer
      kmzLayerURL
      measurementSystem
    }
  }
`;
export const getDTProjects = /* GraphQL */ `
  query GetDTProjects($limit: Int, $nextToken: String) {
    getDTProjects(limit: $limit, nextToken: $nextToken) {
      items {
        id
        projectId
        customerId
        displayName
        lastModifierUserName
        lastModificationDate
        configURL
        withKMZLayer
        kmzLayerURL
        measurementSystem
      }
      nextToken
      limit
    }
  }
`;
export const getDTCustomerProjects = /* GraphQL */ `
  query GetDTCustomerProjects(
    $customerId: String!
    $limit: Int
    $nextToken: String
  ) {
    getDTCustomerProjects(
      customerId: $customerId
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        projectId
        customerId
        displayName
        lastModifierUserName
        lastModificationDate
        configURL
        withKMZLayer
        kmzLayerURL
        measurementSystem
      }
      nextToken
      limit
    }
  }
`;
export const getDTProjectsByUsedDTObject = /* GraphQL */ `
  query GetDTProjectsByUsedDTObject($customerId: String!, $objectId: String!) {
    getDTProjectsByUsedDTObject(customerId: $customerId, objectId: $objectId) {
      id
      projectId
      customerId
      displayName
      lastModifierUserName
      lastModificationDate
      configURL
      withKMZLayer
      kmzLayerURL
      measurementSystem
    }
  }
`;
export const getShadowNode = /* GraphQL */ `
  query GetShadowNode($thingName: String, $shadowName: String) {
    getShadowNode(thingName: $thingName, shadowName: $shadowName) {
      shadow
    }
  }
`;
export const getTimestreamData = /* GraphQL */ `
  query GetTimestreamData($input: TimestreamDataInput) {
    getTimestreamData(input: $input)
  }
`;
export const getStatisticsData = /* GraphQL */ `
  query GetStatisticsData($input: StatisticsDataInput) {
    getStatisticsData(input: $input)
  }
`;
export const getS3Files = /* GraphQL */ `
  query GetS3Files($input: S3FilesInput) {
    getS3Files(input: $input)
  }
`;
export const getProfile = /* GraphQL */ `
  query GetProfile {
    getProfile {
      id
      name
      file
    }
  }
`;
export const getCustomer = /* GraphQL */ `
  query GetCustomer($customerId: String!, $customerExternalId: String!) {
    getCustomer(
      customerId: $customerId
      customerExternalId: $customerExternalId
    ) {
      domains
      id
      externalId
      availableApps
      name
      pointOfContact
      totalLeakFinderLimit
      usageLeakFinderCount
      allowLeakFinder
      configuration
      auditCustomers
      aggAlertingData
      isQuantificationsDisabled
      devicePassword
    }
  }
`;
export const getCustomerCounters = /* GraphQL */ `
  query GetCustomerCounters(
    $customerId: String!
    $customerExternalId: String!
  ) {
    getCustomerCounters(
      customerId: $customerId
      customerExternalId: $customerExternalId
    ) {
      id
      totalLeakFinderLimit
      usageLeakFinderCount
      allowLeakFinder
    }
  }
`;
export const getCustomers = /* GraphQL */ `
  query GetCustomers($limit: Int, $nextToken: String) {
    getCustomers(limit: $limit, nextToken: $nextToken) {
      items {
        domains
        id
        externalId
        availableApps
        name
        pointOfContact
        totalLeakFinderLimit
        usageLeakFinderCount
        allowLeakFinder
        configuration
        auditCustomers
        aggAlertingData
        isQuantificationsDisabled
        devicePassword
      }
      nextToken
      limit
    }
  }
`;
export const getLocations = /* GraphQL */ `
  query GetLocations($customerId: String!, $limit: Int, $nextToken: String) {
    getLocations(
      customerId: $customerId
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        referenceId
        locationData
        tags {
          id
          associationId
          tagName
        }
        devices {
          customerId
          locationId
          locationName
          id
          name
          status
          nodeId
          nodeName
          makeModelId
          cameraIpAddress
          deviceData {
            hasPanTilt
            hasRecordVideo
            hasZoom
            keyFrame
            panTiltIP
            panTiltType
            protocol
            recentFrame
            rtspHost
            sourceVideo
            signedUrlKeyFrame
            signedUrlRecentFrame
          }
          currentPosition {
            pan
            tilt
            zoom
          }
          healthData {
            lastAlive
            isOnline
          }
          skuNumber
          skuName
          serialNumber
          componentSerialNumber
          commissionedAt
          derivedHealth
        }
        timeZone
      }
      nextToken
      limit
    }
  }
`;
export const getEventsPendingHumanValidation = /* GraphQL */ `
  query GetEventsPendingHumanValidation($limit: Int, $nextToken: String) {
    getEventsPendingHumanValidation(limit: $limit, nextToken: $nextToken) {
      items {
        id
        customerId
        locationId
        nodeId
        serviceId
        data
        validationState
        validated_by
        explanation
        eventTime
        audited_by
        transitionInfo
        auditorsExplanation
      }
      nextToken
      limit
    }
  }
`;
export const getEventsPendingHumanValidationByTenant = /* GraphQL */ `
  query GetEventsPendingHumanValidationByTenant(
    $tenantId: String!
    $limit: Int
    $nextToken: String
  ) {
    getEventsPendingHumanValidationByTenant(
      tenantId: $tenantId
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerId
        locationId
        nodeId
        serviceId
        data
        validationState
        validated_by
        explanation
        eventTime
        audited_by
        transitionInfo
        auditorsExplanation
      }
      nextToken
      limit
    }
  }
`;
export const getHumanValidatedEventsForAuditing = /* GraphQL */ `
  query GetHumanValidatedEventsForAuditing($limit: Int, $nextToken: String) {
    getHumanValidatedEventsForAuditing(limit: $limit, nextToken: $nextToken) {
      items {
        id
        customerId
        locationId
        nodeId
        serviceId
        data
        validationState
        validated_by
        explanation
        eventTime
        audited_by
        transitionInfo
        auditorsExplanation
      }
      nextToken
      limit
    }
  }
`;
export const getLocationsByTag = /* GraphQL */ `
  query GetLocationsByTag(
    $customerId: String!
    $tag: String!
    $limit: Int
    $nextToken: String
  ) {
    getLocationsByTag(
      customerId: $customerId
      tag: $tag
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        referenceId
        locationData
        tags {
          id
          associationId
          tagName
        }
        devices {
          customerId
          locationId
          locationName
          id
          name
          status
          nodeId
          nodeName
          makeModelId
          cameraIpAddress
          deviceData {
            hasPanTilt
            hasRecordVideo
            hasZoom
            keyFrame
            panTiltIP
            panTiltType
            protocol
            recentFrame
            rtspHost
            sourceVideo
            signedUrlKeyFrame
            signedUrlRecentFrame
          }
          currentPosition {
            pan
            tilt
            zoom
          }
          healthData {
            lastAlive
            isOnline
          }
          skuNumber
          skuName
          serialNumber
          componentSerialNumber
          commissionedAt
          derivedHealth
        }
        timeZone
      }
      nextToken
      limit
    }
  }
`;
export const getLocationById = /* GraphQL */ `
  query GetLocationById($customerId: String!, $locationId: String!) {
    getLocationById(customerId: $customerId, locationId: $locationId) {
      id
      name
      referenceId
      locationData
      tags {
        id
        associationId
        tagName
      }
      devices {
        customerId
        locationId
        locationName
        id
        name
        status
        nodeId
        nodeName
        makeModelId
        cameraIpAddress
        deviceData {
          hasPanTilt
          hasRecordVideo
          hasZoom
          keyFrame
          panTiltIP
          panTiltType
          protocol
          recentFrame
          rtspHost
          sourceVideo
          signedUrlKeyFrame
          signedUrlRecentFrame
        }
        currentPosition {
          pan
          tilt
          zoom
        }
        healthData {
          lastAlive
          isOnline
        }
        skuNumber
        skuName
        serialNumber
        componentSerialNumber
        commissionedAt
        derivedHealth
      }
      timeZone
    }
  }
`;
export const getForm = /* GraphQL */ `
  query GetForm($customerId: String!, $itemId: String!) {
    getForm(customerId: $customerId, itemId: $itemId) {
      id
      customerId
      fields {
        name
        type
        entries
        itemToQuery
      }
    }
  }
`;
export const getNodes = /* GraphQL */ `
  query GetNodes(
    $locationId: String
    $customerId: String
    $tagId: String
    $includeDevices: Boolean
    $limit: Int
    $nextToken: String
  ) {
    getNodes(
      locationId: $locationId
      customerId: $customerId
      tagId: $tagId
      includeDevices: $includeDevices
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        customerId
        locationId
        id
        nodeName
        nodeId
        level
        referenceId
        devices {
          customerId
          locationId
          locationName
          id
          name
          status
          nodeId
          nodeName
          makeModelId
          cameraIpAddress
          deviceData {
            hasPanTilt
            hasRecordVideo
            hasZoom
            keyFrame
            panTiltIP
            panTiltType
            protocol
            recentFrame
            rtspHost
            sourceVideo
            signedUrlKeyFrame
            signedUrlRecentFrame
          }
          currentPosition {
            pan
            tilt
            zoom
          }
          healthData {
            lastAlive
            isOnline
          }
          skuNumber
          skuName
          serialNumber
          componentSerialNumber
          commissionedAt
          derivedHealth
        }
        serviceData
        deviceData
        onboardCommand
        tags {
          id
          tagName
        }
        nodeIP
        isOnline
      }
      nextToken
      limit
    }
  }
`;
export const getDeviceById = /* GraphQL */ `
  query GetDeviceById($customerId: String!, $deviceId: String!) {
    getDeviceById(customerId: $customerId, deviceId: $deviceId) {
      customerId
      locationId
      locationName
      id
      name
      status
      nodeId
      nodeName
      makeModelId
      cameraIpAddress
      deviceData {
        hasPanTilt
        hasRecordVideo
        hasZoom
        keyFrame
        panTiltIP
        panTiltType
        protocol
        recentFrame
        rtspHost
        sourceVideo
        signedUrlKeyFrame
        signedUrlRecentFrame
      }
      currentPosition {
        pan
        tilt
        zoom
      }
      healthData {
        lastAlive
        isOnline
      }
      skuNumber
      skuName
      serialNumber
      componentSerialNumber
      commissionedAt
      derivedHealth
    }
  }
`;
export const getDevices = /* GraphQL */ `
  query GetDevices(
    $customerId: String!
    $locationId: String
    $nodeId: String
    $limit: Int
    $nextToken: String
  ) {
    getDevices(
      customerId: $customerId
      locationId: $locationId
      nodeId: $nodeId
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        customerId
        locationId
        locationName
        id
        name
        status
        nodeId
        nodeName
        makeModelId
        cameraIpAddress
        deviceData {
          hasPanTilt
          hasRecordVideo
          hasZoom
          keyFrame
          panTiltIP
          panTiltType
          protocol
          recentFrame
          rtspHost
          sourceVideo
          signedUrlKeyFrame
          signedUrlRecentFrame
        }
        currentPosition {
          pan
          tilt
          zoom
        }
        healthData {
          lastAlive
          isOnline
        }
        skuNumber
        skuName
        serialNumber
        componentSerialNumber
        commissionedAt
        derivedHealth
      }
      nextToken
      limit
    }
  }
`;
export const getDeviceMakeById = /* GraphQL */ `
  query GetDeviceMakeById($makeModelId: String!) {
    getDeviceMakeById(makeModelId: $makeModelId) {
      id
      name
      model
      type
      rtspTemplate
      defaultUserPwd
      hasPanTilt
      hasZoom
      modelsToRun
      deviceTypeShortName
    }
  }
`;
export const getDeviceMakeByModel = /* GraphQL */ `
  query GetDeviceMakeByModel($makeModelName: String!) {
    getDeviceMakeByModel(makeModelName: $makeModelName) {
      id
      name
      model
      type
      rtspTemplate
      defaultUserPwd
      hasPanTilt
      hasZoom
      modelsToRun
      deviceTypeShortName
    }
  }
`;
export const getDevicesMakes = /* GraphQL */ `
  query GetDevicesMakes($limit: Int, $nextToken: String) {
    getDevicesMakes(limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        model
        type
        rtspTemplate
        defaultUserPwd
        hasPanTilt
        hasZoom
        modelsToRun
        deviceTypeShortName
      }
      nextToken
      limit
    }
  }
`;
export const getDeviceTemplates = /* GraphQL */ `
  query GetDeviceTemplates($limit: Int, $nextToken: String) {
    getDeviceTemplates(limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        numberOfNodes
        templateData
      }
      nextToken
      limit
    }
  }
`;
export const getSKUs = /* GraphQL */ `
  query GetSKUs($limit: Int, $nextToken: String) {
    getSKUs(limit: $limit, nextToken: $nextToken) {
      items {
        id
        skuNumber
        skuName
        category
        nodeCount
        skuData
        createdAt
      }
      nextToken
      limit
    }
  }
`;
export const getDevicesByLocation = /* GraphQL */ `
  query GetDevicesByLocation($locationId: String!, $nextToken: String) {
    getDevicesByLocation(locationId: $locationId, nextToken: $nextToken) {
      items {
        customerId
        locationId
        locationName
        id
        name
        status
        nodeId
        nodeName
        makeModelId
        cameraIpAddress
        deviceData {
          hasPanTilt
          hasRecordVideo
          hasZoom
          keyFrame
          panTiltIP
          panTiltType
          protocol
          recentFrame
          rtspHost
          sourceVideo
          signedUrlKeyFrame
          signedUrlRecentFrame
        }
        currentPosition {
          pan
          tilt
          zoom
        }
        healthData {
          lastAlive
          isOnline
        }
        skuNumber
        skuName
        serialNumber
        componentSerialNumber
        commissionedAt
        derivedHealth
      }
      nextToken
      limit
    }
  }
`;
export const getZones = /* GraphQL */ `
  query GetZones(
    $customerId: String!
    $serviceId: String!
    $limit: Int
    $nextToken: String
  ) {
    getZones(
      customerId: $customerId
      serviceId: $serviceId
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        pan
        tilt
        deviceId
        status
        serviceId
        inspectTime
        keyFrame
        threshold {
          id
          name
          value
        }
        exclusions
        nodeId
        alertData
        zoom
        shouldNotify
        signedUrlKeyFrame
      }
      nextToken
      limit
    }
  }
`;
export const getZone = /* GraphQL */ `
  query GetZone($customerId: String!, $deviceId: String!, $zoneId: String!) {
    getZone(customerId: $customerId, deviceId: $deviceId, zoneId: $zoneId) {
      id
      name
      pan
      tilt
      deviceId
      status
      serviceId
      inspectTime
      keyFrame
      threshold {
        id
        name
        value
      }
      exclusions
      nodeId
      alertData
      zoom
      shouldNotify
      signedUrlKeyFrame
    }
  }
`;
export const getZonesThresholdsByCustomer = /* GraphQL */ `
  query GetZonesThresholdsByCustomer(
    $input: GetZonesThresholdsByCustomerInput!
  ) {
    getZonesThresholdsByCustomer(input: $input) {
      items {
        id
        name
        value
      }
      nextToken
      limit
    }
  }
`;
export const getZoneThresholdById = /* GraphQL */ `
  query GetZoneThresholdById($input: GetZoneThresholdInput!) {
    getZoneThresholdById(input: $input) {
      id
      name
      value
    }
  }
`;
export const getZonesByDevice = /* GraphQL */ `
  query GetZonesByDevice(
    $deviceId: String!
    $customerId: String!
    $limit: Int
    $nextToken: String
    $filterByCustomer: Boolean
  ) {
    getZonesByDevice(
      deviceId: $deviceId
      customerId: $customerId
      limit: $limit
      nextToken: $nextToken
      filterByCustomer: $filterByCustomer
    ) {
      items {
        id
        name
        pan
        tilt
        deviceId
        status
        serviceId
        inspectTime
        keyFrame
        threshold {
          id
          name
          value
        }
        exclusions
        nodeId
        alertData
        zoom
        shouldNotify
        signedUrlKeyFrame
      }
      nextToken
      limit
    }
  }
`;
export const getAnnotations = /* GraphQL */ `
  query GetAnnotations($input: GetAnnotationsInput!) {
    getAnnotations(input: $input) {
      items {
        id
        serviceId
        deviceId
        zoneId
        polygon
        annotationType
        equipmentType
        annotateTanks
        name
        tankNumber
        tankHeight
        bottomHidden
      }
      nextToken
      limit
    }
  }
`;
export const getSubscriptionsForEmail = /* GraphQL */ `
  query GetSubscriptionsForEmail(
    $entity: String!
    $email: String!
    $limit: Int
    $nextToken: String
  ) {
    getSubscriptionsForEmail(
      entity: $entity
      email: $email
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        entity
        email
      }
      nextToken
      limit
    }
  }
`;
export const getAllEmailsForSubscriptionEntity = /* GraphQL */ `
  query GetAllEmailsForSubscriptionEntity(
    $entity: String!
    $limit: Int
    $nextToken: String
  ) {
    getAllEmailsForSubscriptionEntity(
      entity: $entity
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        entity
        email
      }
      nextToken
      limit
    }
  }
`;
export const getAllSubscriptions = /* GraphQL */ `
  query GetAllSubscriptions($entity: String!, $limit: Int, $nextToken: String) {
    getAllSubscriptions(entity: $entity, limit: $limit, nextToken: $nextToken) {
      items {
        entity
        email
      }
      nextToken
      limit
    }
  }
`;
export const getAllWildCardsForSubscriptionEntity = /* GraphQL */ `
  query GetAllWildCardsForSubscriptionEntity($limit: Int, $nextToken: String) {
    getAllWildCardsForSubscriptionEntity(limit: $limit, nextToken: $nextToken) {
      items {
        wildCard
        entity
        email
      }
      nextToken
      limit
    }
  }
`;
export const getDevicesByNodeId = /* GraphQL */ `
  query GetDevicesByNodeId($nodeId: String!, $nextToken: String) {
    getDevicesByNodeId(nodeId: $nodeId, nextToken: $nextToken) {
      items {
        customerId
        locationId
        locationName
        id
        name
        status
        nodeId
        nodeName
        makeModelId
        cameraIpAddress
        deviceData {
          hasPanTilt
          hasRecordVideo
          hasZoom
          keyFrame
          panTiltIP
          panTiltType
          protocol
          recentFrame
          rtspHost
          sourceVideo
          signedUrlKeyFrame
          signedUrlRecentFrame
        }
        currentPosition {
          pan
          tilt
          zoom
        }
        healthData {
          lastAlive
          isOnline
        }
        skuNumber
        skuName
        serialNumber
        componentSerialNumber
        commissionedAt
        derivedHealth
      }
      nextToken
      limit
    }
  }
`;
export const queryingDevicesByTag = /* GraphQL */ `
  query QueryingDevicesByTag($tagId: String!) {
    queryingDevicesByTag(tagId: $tagId) {
      items {
        customerId
        locationId
        locationName
        id
        name
        status
        nodeId
        nodeName
        makeModelId
        cameraIpAddress
        deviceData {
          hasPanTilt
          hasRecordVideo
          hasZoom
          keyFrame
          panTiltIP
          panTiltType
          protocol
          recentFrame
          rtspHost
          sourceVideo
          signedUrlKeyFrame
          signedUrlRecentFrame
        }
        currentPosition {
          pan
          tilt
          zoom
        }
        healthData {
          lastAlive
          isOnline
        }
        skuNumber
        skuName
        serialNumber
        componentSerialNumber
        commissionedAt
        derivedHealth
      }
      nextToken
      limit
    }
  }
`;
export const getUserById = /* GraphQL */ `
  query GetUserById {
    getUserById {
      id
      externalId
      customer_id
      firstName
      lastName
      email
      user_role
      userSettings
    }
  }
`;
export const getAllAlerts = /* GraphQL */ `
  query GetAllAlerts($customerId: String!, $limit: Int, $nextToken: String) {
    getAllAlerts(
      customerId: $customerId
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        alertName
        alertType
        locationTag
        location
        model
        email
        tag
        node
        customService
        jsonObject
        subscribedLevelEntity
        phoneNumber
        notificationSettingsJson
        createdBy
      }
      nextToken
      limit
    }
  }
`;
export const getUserAlerts = /* GraphQL */ `
  query GetUserAlerts(
    $customerId: String!
    $email: String!
    $limit: Int
    $nextToken: String
  ) {
    getUserAlerts(
      customerId: $customerId
      email: $email
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        alertName
        alertType
        locationTag
        location
        model
        email
        tag
        node
        customService
        jsonObject
        subscribedLevelEntity
        phoneNumber
        notificationSettingsJson
        createdBy
      }
      nextToken
      limit
    }
  }
`;
